import useIsBelowBreakpoint from './useIsBelowBreakpoint';

export default function () {
  return useIsBelowBreakpoint('small');
}
